export default __webpack_public_path__ + "static/media/announcement.18334f2d.svg";